import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '../stores/session'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/app' },
    { path: '/login', component: () => import('../views/LoginView.vue') },
    { path: '/app', component: () => import('../layouts/ConsoleLayout.vue'), children: [
      { path: '', component: () => import('../views/WorkspacesView.vue') },
      { path: 'workspaces/:workspaceId/forms', component: () => import('../views/FormsView.vue') },
      { path: 'workspaces/:workspaceId/forms/:formId', component: () => import('../views/EditorView.vue') },
      { path: 'workspaces/:workspaceId/billing', component: () => import('../views/BillingView.vue') },
      { path: 'workspaces/:workspaceId/forms/:formId/run', component: () => import('../views/RuntimeView.vue') },
      { path: 'admin', redirect: '/app/admin/clients', meta: { platform: true } },
      { path: 'admin/clients', component: () => import('../views/AdminClientsView.vue'), meta: { platform: true } },
      { path: 'admin/clients/:clientId', component: () => import('../views/AdminClientView.vue'), meta: { platform: true } },
      { path: 'admin/users', component: () => import('../views/AdminUsersView.vue'), meta: { platform: true } },
      { path: 'admin/plans', component: () => import('../views/AdminPlansView.vue'), meta: { platform: true } },
      { path: 'workspaces/:workspaceId/integrations', component: () => import('../views/IntegrationsView.vue') },
    ] },
    { path: '/:pathMatch(.*)*', redirect: '/app' },
  ],
})
router.beforeEach(async to => {
  const session = useSessionStore()
  if (!session.initialized) {
    try { await session.restore() }
    catch { if (to.path !== '/login') return { path: '/login', query: { next: to.fullPath } } }
  }
  if (!session.user && to.path !== '/login') return { path: '/login', query: { next: to.fullPath } }
  if (to.meta.platform && (!session.user?.is_superuser || session.platformDenied)) return '/app'
  if (session.user && to.path === '/login') return '/app'
})

